import {DynamicEntity} from "@alphabatem/js_sdk/src/entities/dynamic_entity";
import * as THREE from "three";
import Animatable from "./animatable";

import {TWEEN} from "three/examples/jsm/libs/tween.module.min";
import { Vector3 } from "three";

export class ThreeNPC extends DynamicEntity {

    obj = null;
    animator = new Animatable();

    constructor(uid, modelKey) {
        super(uid, "npc");
        this.setModelKey(modelKey);
    }

    setRotation(rotation) {
        super.setRotation(rotation);
        this.obj.rotation.set(rotation.x, rotation.y, rotation.z);
    }

    setPosition(position) {
        super.setPosition(position);
        this.obj.position.set(position.x, position.y, position.z);
    }

    setScale(scale) {
        super.setScale(scale);
        this.obj.scale.set(scale.x, scale.y, scale.z);
    }

    update(data) {
        super.update(data)

        if (this.obj === null) {
            console.warn("update before obj loaded")
            return
        }

        console.log("Updating", this)

        this.obj.position.set(this.position.x, this.position.y, this.position.z)
        this.obj.rotation.set(this.rotation._x, this.rotation._y, this.rotation._z)
        this.obj.scale.set(this.scale.x, this.scale.y, this.scale.z)
    }

    animate(delta) {
        console.log('this is showing on repeat')
        super.animate(delta);
        this.animator.animate(delta)

        TWEEN.update()
    }

    walk(data) {
        super.walk(data)

        //TODO start animation
        if (this.canAnimate()) {
            this.animate("walk") //TODO animation function
        }
    }

    playAnimation(key) {
        this.animator.play(key)
    }

    smoothlyMoveTo(toPosition) {

        // this.animate("walk")
        
        // this.obj.lookAt({
        //     x: toPosition[0],
        //     y: toPosition[1],
        //     z: toPosition[2],
        // })

        return new Promise((resolve) => {
            // const previous = this.obj.quaternion

            this.obj.lookAt(
                new Vector3(
                    toPosition[0],
                    toPosition[1],
                    toPosition[2],
                )
            )

            // const after = this.obj.quaternion

            // this.obj.quaternion = previous

            // new TWEEN.Tween(this.obj.rotation)
            //     // .Tween(this.obj.rotation)
            //     .to(after, 500)
            //     .onComplete(() => {
            //         // this.controls.enabled = true;
            //         resolve()
            //     })
            //     .start()

            new TWEEN.Tween(this.obj.position)
                .to({
                    x: toPosition[0],
                    y: toPosition[1],
                    z: toPosition[2],
                }, 1200)
                // .easing(TWEEN.Easing.Cubic.Out)
                .onUpdate((e) => {
                    // this.obj.position.copy(e);
                    // this.position = e
    
                }).onComplete(() => {
                    // this.controls.enabled = true;
                    resolve()
                }).start();
        })

    }

    async smoothlyMoveAlong(data) {
        const { positions, repeatable} = data

        for(let i=0; i < positions.length; i++) {
            await this.smoothlyMoveTo(positions[i])
            
            if (i === positions.length - 1 && repeatable) i = -1
        }
    }


    add(modelMgr, scene) {
        if (this.obj !== null)
            return false //Already added

        const lm = modelMgr.getLoadedModel(this.getModelKey())
        if (lm === null || !lm) {
            console.error("NPC::Missing model: ", this.getModelKey())
            return false
        }
        // console.log("NPC::Adding model: ", lm)

        this.obj = new THREE.Group()
        this.obj.name = this.uid
        this.obj.userData.modelID = this.getModelKey()
        this.obj.userData.alphaID = this.uid

        const m = lm.getModel().clone()
        m.name = "sprite"

        this.animator.buildAnimations(m.children[0], lm.getAnimations())


        this.obj.layers.enable(5); //Interaction layer
        m.layers.enable(5); //Interaction layer
        this.obj.add(m)
        scene.add(this.obj)

        // this.mixer = new THREE.AnimationMixer(m.children[0])
        // this.animations.filter(animation => animation.name !== 'TPose').forEach((clip) => {
        //     console.log("NPC::Adding clip: ", clip)
        //     this.animationsMap[clip.name] = this.mixer.clipAction(clip)
        //     this.animationsMap[clip.name].loop = THREE.LoopRepeat
        // })
        // console.log("NPC::Animations:", {
        //     animations: this.animations,
        //     mapper: this.animationsMap,
        // })

        if (this.canAnimate()) {
            console.log("NPC::Animating", this.animator.animationsMap)
            this.animator.play(Object.keys(this.animator.animationsMap)[0])
        }

        return true
    }
}
